/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, OnInit, Output, OnChanges, Input, EventEmitter, ViewEncapsulation, ViewChild, SimpleChanges } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ChangeSponsorConfimationModalComponent } from "./change-sponsor-confimation-modal.component"
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../shared/services/common.service';
import { ChangeSponsorService } from './change-sponsor.service';
import { AfterViewInit } from '@angular/core';
import { CHANGE_SPONSOR } from '../../config/constants';
import { TranslateService } from '@ngx-translate/core';
import { COMPANY_CODES } from '../../config/constants';
import moment from 'moment';
import { PlanPeriodsService } from '../../shared/services/planperiods.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';

@Component({
  selector: 'change-sponsor',
  templateUrl: './change-sponsor.component.html',
  styleUrls: ['./change-sponsor.component.scss'],
  providers: [ChangeSponsorService],
  encapsulation: ViewEncapsulation.None
})
export class ChangeSponsorComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('sponsorForm') sponsorForm!: NgForm;
  @Output() closeSlider: EventEmitter<any> = new EventEmitter();
  @Input() sponsor: any;
  private currentDate: Date = new Date();
  private globalDateFormatVar: any = localStorage.getItem('globalDateFormat');
  public datePickerOptions: Partial<BsDatepickerConfig> = {
    dateInputFormat: this.globalDateFormatVar
      ? this.globalDateFormatVar.toUpperCase()
      : 'MMM DD, YYYY',
      adaptivePosition: false,
      showTodayButton: true,
      todayPosition: 'center'
    // Because of below code Facing issue in change sponsor submit functionality.
    // disableUntil: {
    //   year: this.currentDate.getFullYear(),
    //   month: this.currentDate.getMonth() + 1,
    //   day: this.currentDate.getDate() - 1
    // }
  };
  public sponsorPayload: any = {};
  public sponsorData: any = {};
  public validationObj = {
    userMessage: '',
    state: ''
  };
  public notificationOptions = {
    timeOut: 4000,
    showProgressBar: true,
    pauseOnHover: true,
    clickToClose: true,
    maxLength: 0,
    position: ['right', 'top']
  };
  public isSponsorChanged = false;
  public fromSponsorInfo: any;
  public currentSponsor: any;
  public currentEnroller: any;
  public newSponsor: any;
  public newEnroller: any;
  public btnSubmit = true;
  public changeSponsorConst = CHANGE_SPONSOR;
  public genTypes: any = {};
  public confResponse: any;
  public hasRequiredError = false;
  public isFormSubmitted = false;
  public hasChangeAccess = true;
  public newSponsorInactive = false;
  public participantInactive = false;
  public participantSame = false;
  public defaultSearchText = '';
  // MLM - 2777
  public isCompanyConfigNone = false;
  public today = new Date();
  public menuObj: any = {};
  public changeSponsorObj: any;
  public companyCodes: any;
  public companyCode: any;
  public isChangeManagerAccess = true;
  public periodDetails: any;
  public startPeriodDateInMillis: any;
  private defaultConfig: ModalOptions = {
    backdrop: true,
    ignoreBackdropClick: true
  };

  constructor(
    public modalService: BsModalService,
    private translate: TranslateService,
    private toastr: ToastrService,
    public ChangeSponsorService: ChangeSponsorService,
    public planPeriodsService: PlanPeriodsService,
    public commonService: CommonService
  ) {
    this.companyCodes = COMPANY_CODES;
    this.resetValidationErrorMessage();
    this.genTypes[CHANGE_SPONSOR.participant] = this.getTranslationWithKey('salesforce_only') || '';
    this.genTypes[CHANGE_SPONSOR.personalGroup] = this.getTranslationWithKey('salesforce_and_personal') || '';
    this.genTypes[CHANGE_SPONSOR.downlineLeg] = this.getTranslationWithKey('salesforce_and_downline') || '';
    const menuId = this.commonService.getMenuId('CSR');
      this.commonService.setHelpObj({
        header: this.getTranslationWithKey('CSR') || '',
        menuId: menuId,
        sections: [],
        lastSavedData: [],
        relatedLinks: [
          {
            label: this.getTranslationWithKey('FLP'),
            url: '/fieldsupport/distributorList/default'
          },
          {
            label: this.getTranslationWithKey('GLY'),
            url: '/genealogyHome/genealogy/default'
          }
        ]
      });
    // this.translate.get('common.help').subscribe(helpObj => {
    //   this.commonService.setHelpObj({
    //     header: this.menuObj.CSR || '',
    //     menuId: menuId,
    //     sections: [],
    //     lastSavedData: [],
    //     relatedLinks: [
    //       {
    //         label: this.menuObj.FLP,
    //         url: '/fieldsupport/distributorList/default'
    //       }, {
    //         label: this.menuObj.GLY,
    //         url: '/genealogyHome/genealogy/default'
    //       }
    //     ]
    //   });
    // });
  }

  ngOnInit() {
    this.hasChangeAccess = this.commonService.hasFeatureAccess('Change Sponsor');
    // Added below logic to fix VCE-5595 and VCE-5662
    const userInfo = this.commonService.getUserDetails();
    if (userInfo && userInfo.permissions && userInfo.permissions.details) {
      const detailObj = userInfo.permissions.details.find((detailObj: any) => detailObj.code === 'GEN');
      if(detailObj != undefined) {
        if (detailObj.code === 'GEN') {
          if (detailObj.permission.code === 'RAC') {
            this.isChangeManagerAccess = false;
          }
        }
      } else {
        this.isChangeManagerAccess = false;
      }  
    }
    this.companyCode = this.commonService.getCompanyCode();
    this.isSponsorChanged = false;
    this.resetValidationErrorMessage();
    this.setEffectiveDate();
    this.getPeriodDetails();
    /* MLM-2777 - start */
    const leadershipFunction = this.commonService.getGenealogyConfiguration();
    if (leadershipFunction) {
      this.isCompanyConfigNone = leadershipFunction.name === 'None';
    }
    /* MLM-2777 - end */
    // VCE - 3549 - "Period Close" check box to be selected By Default
    this.sponsorPayload.periodClose = true;
  }

  public getTranslationWithKey(key: string) {
    return this.commonService.getTranslatedVal(key);
  }

  private getPeriodDetails() {
    this.planPeriodsService
      .getPeriod()
      .then(this.getPeriodDetailsSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
  }

  private getPeriodDetailsSH(response: any) {
    this.periodDetails = response;
    if (this.periodDetails) {
      this.checkPeriodClose();
    }
  }

  // 4567 - "Set next period Start date, if Period Close got selected, othewise set currentDate"
  public checkPeriodClose() {
    if (this.sponsorPayload.periodClose) {
      this.startPeriodDateInMillis = moment(this.periodDetails.currentPeriod && this.periodDetails.currentPeriod.endDate).add(1, 'days').valueOf();
      this.sponsorPayload.effectiveDate = this.commonService.prepareBSDateObj(this.startPeriodDateInMillis);
    } else {
      this.sponsorPayload.effectiveDate = this.commonService.prepareBSDateObj(this.currentDate.getTime());
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['sponsor'] && changes['sponsor'].currentValue) {
      this.defaultSearchText = changes['sponsor'].currentValue?.clientId;
      this.fromClientSelected(changes['sponsor'].currentValue);
    }
  }

  ngAfterViewInit() {
    this.sponsorForm.control.valueChanges.subscribe(() => {
      if (this.sponsorForm.form.invalid) {
        this.hasRequiredError = this.commonService.hasRequiredError(this.sponsorForm.form.controls);
      } else {
        this.isFormSubmitted = false;
        this.hasRequiredError = false;
      }
    });
  }

  private setEffectiveDate() {
    this.sponsorPayload.effectiveDate = this.commonService.prepareBSDateObj(new Date().getTime());
  }

  public close() {
    this.isSponsorChanged = false;
    this.closeSlider.emit();
  }

  public sponsorTypeChange() {
    if (this.sponsorPayload.client !== undefined) {
      this.currentSponsor = this.sponsorPayload.client.sponsor;
      this.setFullName(this.currentSponsor);
    }
  }

  public enrollerTypeChange() {
    if (this.sponsorPayload.client !== undefined) {
      this.currentEnroller = this.sponsorPayload.client.enroller;
      this.setFullName(this.currentEnroller);
    }
  }

  // public onChangeGenealogyMoveType() {

  // }

  public confimationPopUp() {
    const form = this.sponsorForm.form;
    this.isFormSubmitted = true;
    this.hasRequiredError = false;
    this.newSponsorInactive = false;
    this.participantInactive = false;
    if (form.invalid || !this.hasValidFormData()) {
      this.hasRequiredError = this.commonService.hasRequiredError(form.controls) || !this.hasValidFormData();
    } else if (
      this.sponsorPayload.client.status &&
      (this.sponsorPayload.client.status.code == 'INA' || this.sponsorPayload.client.status.code == 'SUS')
    ) {
      /*Participant Inactive/Suspended/None */
      this.participantInactive = true;
    } else if (
      this.sponsorPayload.toClient.status &&
      (this.sponsorPayload.toClient.status.code == 'INA' || this.sponsorPayload.toClient.status.code == 'SUS')
    ) {
      /*New Sponsor Inactive/Suspended/None */
      this.newSponsorInactive = true;
    } else {
      this.isFormSubmitted = false;
      this.isSponsorChanged = false;
      this.setFullName(this.sponsorPayload.client);
      this.setFullName(this.sponsorPayload.toClient);
      this.sponsorData['fromName'] = this.sponsorPayload.client.name;
      this.sponsorData['toName'] = this.sponsorPayload.toClient.name;
      this.sponsorData['type'] = this.sponsorPayload.sponsorType ? this.getTranslationWithKey('sponsor') : '';
      this.sponsorData['currentSponsor'] = this.currentSponsor;
      this.sponsorData['applyType'] = this.sponsorPayload.applyType;
      this.sponsorData['sponsorType'] = this.sponsorPayload.sponsorType;
      this.sponsorData['newSponsor'] = this.newSponsor;
      const initialState = {
        context: {
          isFrom: 'SponsorChange',
          data: this.sponsorData
        }
      };
      
      const modalRef: BsModalRef = this.modalService.show(ChangeSponsorConfimationModalComponent, {
        ...this.defaultConfig,
        initialState,
        class:'modal-dialog change-sponsor-reg-ter-modal'
      });
      
      // Handle modal close event
      modalRef.content?.closeModal.subscribe((result: any) => {
        if (result) {
          this.changeSponsorShip(result);
        }
      });
    }
  }

  private hasValidFormData() {
    this.participantSame = false;
    const cond =
      this.sponsorPayload.client &&
      (!this.sponsorPayload.sponsorType || this.sponsorPayload.toClient) &&
      this.sponsorPayload.client.sponsor?.clientId !== this.sponsorPayload.toClient?.clientId;
    if (
      this.sponsorPayload.client &&
      this.sponsorPayload.toClient &&
      this.sponsorPayload.client.sponsor?.clientId == this.sponsorPayload.toClient?.clientId
    ) {
      this.participantSame = true;
      // this.sponsorPayload.toClient = '';
    }
    return cond;
  }

  private setFullName(sponsor: any) {
    if (sponsor) {
      const firstName = sponsor.firstName || '',
        lastName = sponsor.lastName || '';
      sponsor.name = `${firstName} ${lastName}`;
    }
  }

  private resetValidationErrorMessage() {
    this.validationObj = {
      userMessage: '',
      state: ''
    };
  }

  public changeSponsorShip(result: any) {
    let effectiveDate: any;
    if(this.sponsorPayload.periodClose) {
      effectiveDate = this.startPeriodDateInMillis;
    } else {
      effectiveDate = new Date().getTime();
    }
    if (result === 'confirmed') {
      const payload = {
        sponsorType: this.sponsorPayload.sponsorType ? 'sponsor' : '',
        comments: this.sponsorPayload.comments,
        applyType: this.sponsorPayload.applyType,        
        effectiveDate: effectiveDate,
        periodClose: !!this.sponsorPayload.periodClose
      };
      this.ChangeSponsorService.changeSponsor(
        payload,
        this.sponsorPayload.client?.clientId,
        this.sponsorPayload.toClient?.clientId
      ).then(this.successHandler.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
    }
  }

  private successHandler(result: any) {
    const res = result;
    if (res && res.leader) {
      this.setFullName(res.leader);
    }
    this.commonService.setUpdateChangeSponsorScheduledJobs('Success');
    this.confResponse = res;
    this.resetValidationErrorMessage();
    this.isSponsorChanged = true;
    this.toastr.success(this.getTranslationWithKey('operation_success'), this.getTranslationWithKey('success'));
  }

  public fromClientSelected(event: any) {
    const leadershipFunction = this.commonService.getGenealogyConfiguration();
    if (leadershipFunction) {
      this.isCompanyConfigNone = leadershipFunction.name === 'None';
    }
    this.participantInactive = false;
    this.sponsorPayload.client = event;
    if (!this.isCompanyConfigNone) {
      this.sponsorPayload.applyType = this.changeSponsorConst.participant;
    } else {
      this.sponsorPayload.applyType = this.changeSponsorConst.downlineLeg;
    }
    this.sponsorTypeChange();
    this.enrollerTypeChange();
  }

  public toClientSelected(event: any) {
    this.newSponsorInactive = false;
    this.sponsorPayload.toClient = event;
    if (this.sponsorPayload.toClient !== undefined) {
      this.newSponsor = this.sponsorPayload.toClient;
      this.setFullName(this.newSponsor);
    }
  }

  public toEnrollerSelected(event: any) {
    this.sponsorPayload.toEnrollerClient = event;
    if (this.sponsorPayload.toEnrollerClient !== undefined) {
      this.newEnroller = this.sponsorPayload.toEnrollerClient;
      this.setFullName(this.newEnroller);
    }
  }

  public clearDistributorSearch() {
    const effDate = this.sponsorPayload.effectiveDate;
    this.currentSponsor = null;
    this.currentEnroller = null;
    this.sponsorPayload = {};
    this.sponsorPayload.effectiveDate = effDate;
    // VCE - 3549 - "Period Close" check box to be selected By Default
    this.sponsorPayload.periodClose = true;
    this.checkPeriodClose();
  }
}
